import React from 'react';
import {
  Sun,
  Users,
  Bed,
  PawPrint,
  ShieldCheck,
  Sparkle,
} from '@phosphor-icons/react';
import ServicePage from './ServicePage';

const facilities = [
  { icon: Sun, label: 'Indoor & outdoor zones', sub: 'Switch between play and rest freely' },
  { icon: Users, label: 'Supervised play groups', sub: 'Matched by size and temperament' },
  { icon: Bed, label: 'Quiet nap corners', sub: 'Soft mats away from the action' },
  { icon: PawPrint, label: 'Enrichment activities', sub: 'Puzzles and gentle training games' },
  { icon: ShieldCheck, label: 'Trained handlers', sub: 'Eyes-on supervision all day' },
  { icon: Sparkle, label: 'Clean spaces', sub: 'Sanitised play zones every day' },
];

const gallery = [
  {
    url: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=1200&q=80',
    title: 'Group play',
    description: 'Curated playgroups for safe, social fun.',
  },
  {
    url: 'https://images.pexels.com/photos/4148015/pexels-photo-4148015.jpeg?auto=compress&cs=tinysrgb&w=1200',
    title: 'Indoor lounges',
    description: 'Air-conditioned spaces for warm afternoons.',
  },
  {
    url: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&w=1200&q=80',
    title: 'Rest time',
    description: 'Naps and downtime built into the day.',
  },
];

const highlights = [
  'Half-day and full-day options',
  'Snack and water breaks throughout the day',
  'Separate zones for puppies and senior dogs',
  'Soft entry process for first-time visitors',
];

const Daycare = () => (
  <ServicePage
    eyebrow="Day Care"
    title="A bright, busy day for your pet"
    lede="Drop off in the morning, pick up a happy, tired dog. Supervised play, calm rests and lots of company in between."
    heroImage="https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=2000&q=80"
    heroAlt="Dogs playing during daycare"
    intro="Our day care follows a rhythm that mirrors a dog’s natural day — bursts of play, social time, snacks and quiet rests. Every group is small enough that handlers know each dog by name."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Tired in the best way"
    closingBody="A full day of safe play and rest means your dog comes home content, exercised and ready to wind down with you."
  />
);

export default Daycare;
